import React, { useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { PrinterDiv } from './styles';

import ComponentToPrint from '../ComponentToPrint';
import { useToast } from '../../../hooks/toast';
import { IOrder } from '../../../interfaces/IOrder';
import { IDeliveryAddress } from '../../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../../interfaces/IOrderItem';

interface CustomPrinterProps extends React.HTMLAttributes<HTMLDivElement> {
  pedido: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  };
  children: React.ReactNode;
}

const CustomPrinter: React.FC<CustomPrinterProps> = ({
  pedido,
  children,
  ...rest
}) => {
  const inputEl = useRef(null);

  const { addToast } = useToast();

  const handlePrint = useReactToPrint({
    content: () => inputEl.current,
  });

  return (
    <>
      <PrinterDiv
        onClick={() => {
          handlePrint && handlePrint();
          addToast({
            title: 'Gerando impressão...',
            type: 'info',
          });
        }}
        {...rest}
      >
        {children}
      </PrinterDiv>

      <div style={{ display: 'none' }}>
        <ComponentToPrint ref={inputEl} pedido={pedido} />
      </div>
    </>
  );
};

export default CustomPrinter;
